import IconSVG from 'svg-inline-react'
import cx from 'classnames'

import TinyEditorModal from '../TinyEditorModal'
import Tag from 'shared-web/src/components/Tag'
import ConditionalRender from 'components/shared/ConditionalRender'

import socialSplashSrc from '!svg-inline?removeTags=true!images/svg/social-splash.svg'

import './style.styl'

// todo: move to constants
export const TokenModalSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm',
}

export const PropertyNamespaces = {
  USER: 'user',
  CLEARBIT: 'clearbit',
  ACCOUNT: 'account',
  SENDER: 'sender',
}

const TokenModalSelect = ({
  userProperties,
  clearbitProperties,
  senderProperties,
  search,
  onSearchChange,
  onPropertySelect,
  selectedTab,
  onClearbitTabClick,
  onUserTabClick,
  noPropertiesShown,
  hideClearbitTab,
  hasClearbitEnabled,
}) => (
  <div className="modal-selector-container">
    <div className="modal-selector-section modal-selector-section-top drift-form">
      <input
        className="modal-selector-search-input"
        type="text"
        value={search}
        onChange={onSearchChange}
        placeholder="Search"
      />
    </div>
    {!hideClearbitTab && hasClearbitEnabled &&
      <div className="modal-selector-tab-container">
        <span className={cx('modal-selector-tab-option', { active : selectedTab === PropertyNamespaces.USER })} onClick={onUserTabClick}>User</span>
          <span className={cx('modal-selector-tab-option', { active : selectedTab === PropertyNamespaces.CLEARBIT })} onClick={onClearbitTabClick}>Clearbit</span>
      </div>
    }
    <div className="tiny-token-modal-options">
      {selectedTab === PropertyNamespaces.USER &&
       userProperties.map(({ displayName, name, namespaceOverride }) => (
        <div key={name} className="tiny-token-modal-option" onClick={() => onPropertySelect(name, namespaceOverride || PropertyNamespaces.USER)}>
          <Tag className="tiny-token" tag={{ name }} />
          <span className="tiny-token-modal-option-name">{displayName}</span>
        </div>
      ))}
      {selectedTab === PropertyNamespaces.CLEARBIT &&
       clearbitProperties.map(({ displayName, name }) => (
        <div key={name} className="tiny-token-modal-option" onClick={() => onPropertySelect(name, PropertyNamespaces.CLEARBIT)}>
          <Tag className="tiny-token" tag={{ name }} />
          <span className="tiny-token-modal-option-name">{displayName}</span>
        </div>
      ))}
      {selectedTab === PropertyNamespaces.SENDER &&
       senderProperties.map(({ displayName, name }) => (
        <div key={name} className="tiny-token-modal-option" onClick={() => onPropertySelect(name, PropertyNamespaces.SENDER)}>
          <Tag className="tiny-token" tag={{ name }} />
          <span className="tiny-token-modal-option-name">{displayName}</span>
        </div>
      ))}
      <ConditionalRender className="modal-selector-empty-options" condition={noPropertiesShown}>
        <IconSVG src={socialSplashSrc} />
        <p>There are no personalization attributes matching your search.</p>
      </ConditionalRender>
    </div>
  </div>
)

const TokenModalConfirm = ({ onDefaultCancel, onDefaultConfirm, selectedProperty, onDefaultChange }) => (
  <div className="modal-selector-container">
    <div className="modal-selector-section modal-selector-section-top">
      <span className="modal-selector-property-preview">{selectedProperty.name}</span>
      <span onClick={onDefaultCancel} className="link preview-edit-link">
        Change
      </span>
    </div>
    <div className="drift-form modal-token-confirm-form">
      <label className="default-form-label">Default Value:</label>
      <input type="text" placeholder="enter default..." onChange={onDefaultChange} />
      <p className="default-form-extra-details">
        Default values display when a contact doesn‘t have a value for this variable
      </p>
    </div>

    <div className="modal-selector-section modal-selector-section-bottom">
      <div onClick={onDefaultConfirm} className="modal-selector-section-button drift-button drift-button-primary">
        Insert
      </div>
      <div onClick={onDefaultCancel} className="modal-selector-section-button drift-button drift-button-secondary">
        Cancel
      </div>
    </div>
  </div>
)

export const EditorTokenModal = ({ modalStep, hideTokenModal, ...rest }) => (
  <TinyEditorModal title={"Insert Personalization"} onClose={hideTokenModal}>
    <div className="playbook-token-modal">
      <div className="tiny-token-modal">
        {modalStep === TokenModalSteps.SELECT && <TokenModalSelect {...rest} />}
        {modalStep === TokenModalSteps.CONFIRM && <TokenModalConfirm {...rest} />}
      </div>
    </div>
  </TinyEditorModal>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorTokenModal/component.js